import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=46489e02&scoped=true&"
import script from "./Appointment.vue?vue&type=script&lang=js&"
export * from "./Appointment.vue?vue&type=script&lang=js&"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=46489e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46489e02",
  null
  
)

export default component.exports